import Vue from 'vue'
import Router from 'vue-router'
import Landing from '@/components/Landing'
import Works from '@/components/Works'
import Experiments from '@/components/Experiments'
import About from '@/components/About'
import WorkDetail from '@/components/WorkDetail'
// import Search from '@/components/Search'
// import Boards from '@/components/Boards'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Landing',
      component: Landing
    },
    {
      path: '/works',
      name: 'Works',
      component: Works,
      // children: [
      //   {
      //     path: ':workName',
      //     component: WorkDetail
      //   }
      // ]
    },
    {
      path: '/experiments',
      name: 'Experiments',
      component: Experiments,
      // children: [
      //   {
      //     path: ':workName',
      //     component: WorkDetail
      //   }
      // ]
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/works/:workName',
      name: 'WorkDetail',
      component: Works
    },
    {
      path: '/experiments/:workName',
      name: 'ExperimentDetail',
      component: Experiments
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js